import React from "react";
import DatePicker from "react-datepicker";
import { FieldProps } from "formik";
import { get } from "../utils/get";
import styled from "styled-components";
import moment from "moment";

const CustomInput = ({ placeholder, value, ...props }: any) => {
  return (
    <InputContainer>
      <DatePickerInput value={value} placeholder={placeholder} {...props} />
    </InputContainer>
  );
};

export const DateTimePicker = ({
  label,
  isClearable,
  width,
  field: { value, name },
  form: { setFieldValue },
}: { label?: string; isClearable?: boolean; width: string } & FieldProps) => {
  return (
    <>
      {label && <DateLabel>{label}</DateLabel>}
      <DatePicker
        selected={value}
        onChange={(date) => {
          console.log(date, value);

          setFieldValue(name, date);
        }}
        timeInputLabel="Time:"
        dateFormat="MM/dd/yyyy HH:mm"
        showTimeInput
        minDate={moment().toDate()}
        customInput={
          <CustomInput value={value} placeholder="Select date" width={width} />
        }
      />
    </>
  );
};

const InputContainer = styled.div`
  position: relative;
  width: 100%;
`;

const DatePickerInput = styled.input<{ width: string }>`
  padding: 1em 1em;
  padding-left: 2em;
  font-weight: normal;
  font-size: 12px;
  background-color: #fff;
  font-weight: bold;
  color: #214160;
  box-shadow: none;
  width: ${(props) => props.width};
  border: 1px solid rgba(33, 65, 96, 0.6);
  border-radius: 0.5em;
  display: flex;
  align-items: center;
  ::placeholder {
    color: #999;
    font-size: 0.9rem;
  }
`;

const DateLabel = styled.label`
  color: rgba(33, 65, 96, 0.4);
  font-size: 0.75em;
`;
